import { svgPaths, facilitySvgPaths, menuSvgPaths, parkingSvgPaths, LogoContainer, EventContainer, MainContainer } from '../../imports/svgPaths';
// import.*from.*imports/svg-8txpwpskyh";
// import.*from.*imports/svg-0b7y5uk2mo";

// Usage Guide Section Title
function Container13() {
  return (
    <div
      className="box-border content-stretch flex flex-col gap-6 lg:gap-10 items-center justify-start leading-[0] not-italic p-0 relative shrink-0 text-nowrap"
      data-name="Container"
    >
      <div className="font-paperlogy font-bold relative shrink-0 text-center text-neutral-950 tracking-[-0.96px]">
        <p className="leading-[normal] text-[min(48px,_7vw)] text-nowrap whitespace-pre">
          <span className="font-paperlogy font-medium">이렇게 </span>
          <span className="font-paperlogy font-extrabold font-bold">이용하실 수</span>
          <span className="adjustLetterSpacing font-paperlogy font-medium"> 있어요</span>
        </p>
      </div>
    </div>
  );
}

// Usage Info Cards
function UsageInfoCard() {
  return (
    <div className="bg-[#ffffff] border border-[#eaeaea] box-border content-stretch flex flex-col gap-6 items-start justify-start leading-[0] not-italic px-6 lg:px-10 py-6 lg:py-8 relative rounded-2xl shrink-0 text-left text-neutral-950 w-full h-full">
      <div className="font-paperlogy font-medium relative shrink-0 text-[20px] tracking-[-0.4px]">
        <p className="block leading-[normal] font-bold">이용안내</p>
      </div>
      <div className="font-paperlogy font-normal leading-[normal] relative flex-1 text-[16px] tracking-[-0.32px] w-full">
        <p className="block mb-0"><strong>[ 대/소인 기준 ]</strong></p>
        <p className="block mb-0">- 소인 : 12개월 이상 ~ 14세 미만</p>
        <p className="block mb-0">- 대인 : 14세 이상 ~</p>
        <p className="block mb-4">- 12개월 미만까지 무료입장 (증빙서류 지참)</p>
        <p className="block mb-0"><strong>[ 운영시간 ]</strong></p>
        <p className="block mb-0">- 평일 : 단체 예약만 운영 (사전 문의·예약 필수)</p>
        <p className="block mb-0">- 주말/공휴일 : 정상 영업 10:00 ~ 20:00</p>
        <p className="block mb-0">- 단체 예약 문의 : 매장으로 연락 부탁드립니다</p>
        <p className="block">- 기본이용시간 초과 10분당 소인 1,000원 초과 요금(대인제외)</p>
      </div>
    </div>
  );
}

function CautionCard() {
  return (
    <div className="bg-[#ffffff] border border-[#eaeaea] box-border content-stretch flex flex-col gap-6 items-start justify-start leading-[0] not-italic px-6 lg:px-10 py-6 lg:py-8 relative rounded-2xl shrink-0 text-left text-neutral-950 w-full h-full">
      <div className="font-paperlogy font-medium relative shrink-0 text-[20px] tracking-[-0.4px]">
        <p className="block leading-[normal] font-bold">유의사항</p>
      </div>
      <div className="font-paperlogy font-normal leading-[normal] relative flex-1 text-[16px] tracking-[-0.32px] w-full">
        <p className="block mb-0">- 어린이는 보호자 없이 이용이 불가합니다.</p>
        <p className="block mb-0">- 활동하기 편한 복장과 양말을 착용하세요. (양말 필수)</p>
        <p className="block mb-0">- 위생 관리 상 외부 음식 반입을 금지합니다. * 이유식 제외</p>
        <p className="block mb-0">- 원활한 체험을 위해 애완동물은 출입이 금지됩니다.</p>
        <p className="block">- 고객님 부주의로 일어난 사고 및 도난, 분실사건은 당사가 책임지지 않습니다.</p>
      </div>
    </div>
  );
}

// Parking Layout Diagram Component (원본 복원)
function ParkingLayoutComponent() {
  return (
    <div
      className="[grid-area:1_/_1] h-[206.023px] ml-0 mt-0 overflow-clip relative w-[467.544px]"
      data-name="_寃⑸━_紐⑤뱶"
    >
      <div
        className="absolute bottom-0 left-[45.9%] right-[0.08%] top-0"
        data-name="Vector"
      >
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 253 207"
        >
          <path
            d={parkingSvgPaths.pbe41380}
            fill="#719072"
            id="Vector"
          />
        </svg>
      </div>
      <div
        className="absolute bottom-0 left-0 right-[62.91%] top-0"
        data-name="Vector"
      >
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 174 207"
        >
          <path
            d={parkingSvgPaths.p33b75c40}
            fill="#719072"
            id="Vector"
          />
        </svg>
      </div>
      <div className="absolute font-paperlogy font-medium inset-[63.1%_17.3%_28.16%_63.03%] leading-[0] not-italic text-[#ffffff] text-[16px] text-center tracking-[-0.32px]">
        <p className="adjustLetterSpacing block leading-[1.4]">비스타 1차</p>
      </div>
      <div className="absolute font-paperlogy font-medium inset-[63.1%_71.41%_28.16%_8.48%] leading-[0] not-italic text-[#ffffff] text-[16px] text-center tracking-[-0.32px]">
        <p className="adjustLetterSpacing block leading-[1.4]">비스타 2차</p>
      </div>
    </div>
  );
}

// Entrance Label Component (원본 복원)
function EntranceLabel() {
  return (
    <div
      className="[grid-area:1_/_1] bg-[#333333] h-[19.077px] ml-[198.718px] mt-[197.923px] relative w-[31.795px]"
      data-name="Container"
    >
      <div
        className="absolute font-paperlogy font-semibold leading-[0] not-italic text-[#ffffff] text-[16px] text-left text-nowrap tracking-[-0.32px]"
        style={{ top: "calc(50% - 9.538px)", left: "calc(50% - 13.897px)" }}
      >
        <p className="adjustLetterSpacing block leading-[normal] whitespace-pre">
          입구
        </p>
      </div>
    </div>
  );
}

// Combined Parking Diagram with Arrow (원본 복원)
function ParkingDiagramContainer() {
  return (
    <div
      className="grid-cols-[max-content] grid-rows-[max-content] inline-grid leading-[0] place-items-start relative shrink-0"
      data-name="Container"
    >
      <ParkingLayoutComponent />
      <div className="[grid-area:1_/_1] flex h-[188.375px] items-center justify-center ml-[193.154px] mt-[28.615px] relative w-[195.531px]">
        <div className="flex-none rotate-[270deg]">
          <div className="h-[195.538px] relative w-[188.385px]">
            <div className="absolute bottom-0 left-0 right-[-6.13%] top-[-1.02%]">
              <svg
                className="block size-full"
                fill="none"
                preserveAspectRatio="xMidYMid slice"
                viewBox="0 0 200 198"
              >
                <path
                  d={parkingSvgPaths.p15fce000}
                  fill="#333333"
                  id="Arrow 1"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <EntranceLabel />
    </div>
  );
}

// Warning Message Box (원본 복원)
function WarningMessageBox() {
  return (
    <div
      className="bg-[#f9f9f9] relative rounded-2xl shrink-0 w-full"
      data-name="Container"
    >
      <div className="flex flex-row items-center justify-center relative size-full">
        <div className="box-border content-stretch flex flex-row gap-2.5 items-center justify-center p-[16px] relative w-full">
          <div className="basis-0 font-paperlogy font-normal grow leading-[0] min-h-px min-w-px not-italic relative shrink-0 text-[#333333] text-[16px] text-left tracking-[-0.32px]">
            <p className="block leading-[1.4] mb-0 text-nowrap">
              비스타2차 지하 주차비 지원이 되지 않으니
            </p>
            <p className="leading-[1.4] text-nowrap">
              <span className="text-[#d53939]">
                꼭! 키즈카페 건물인 비스타1차에만 주차
              </span>
              해 주세요!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

// Parking Info Text Section (원본 복원)
function ParkingInfoSection() {
  return (
    <div
      className="box-border content-stretch flex flex-col gap-6 items-start justify-start p-0 relative shrink-0 w-[350px]"
      data-name="Container"
    >
      <div className="font-paperlogy font-normal leading-[normal] not-italic relative shrink-0 text-[#333333] text-[0px] text-left text-nowrap tracking-[-0.48px] whitespace-pre">
        <p className="adjustLetterSpacing block mb-0 text-[24px]">
          비스타1차 지하 주차장
        </p>
        <p className="adjustLetterSpacing block font-paperlogy font-bold text-[40px] font-bold">
          3시간 무료주차
        </p>
      </div>
      <WarningMessageBox />
    </div>
  );
}

// Main Parking Content Container (원본 복원)
function ParkingContentContainer() {
  return (
    <div
      className="box-border content-stretch flex flex-col gap-10 items-start justify-start p-0 relative shrink-0 z-10"
      data-name="Container"
    >
      <div className="font-paperlogy font-medium leading-[0] not-italic relative shrink-0 text-[20px] text-center text-neutral-950 text-nowrap tracking-[-0.4px]">
        <p className="adjustLetterSpacing block leading-[normal] whitespace-pre font-bold">
          주차장 안내
        </p>
      </div>
      <ParkingDiagramContainer />
      <ParkingInfoSection />
    </div>
  );
}

// Background Car Component (원본 복원)
function BackgroundCarComponent() {
  return (
    <div
      className="absolute bottom-[-20px] h-[280px] w-[350px] left-[300px] lg:left-[350px] xl:left-[400px] z-0"
      data-name="_寃⑸━_紐⑤뱶"
    >
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="xMidYMid slice"
        viewBox="0 0 320 255"
      >
        <g id="_å¯â¸â_ï§â¤ë±¶">
          <g id="Group">
            <path
              d={parkingSvgPaths.p1329d580}
              fill="#EAEAEA"
              id="Vector"
            />
            <path
              d={parkingSvgPaths.p10b7400}
              fill="#EAEAEA"
              id="Vector_2"
            />
          </g>
          <g id="Group_2">
            <path
              d={parkingSvgPaths.p28af7300}
              fill="#EAEAEA"
              id="Vector_3"
            />
            <path
              d={parkingSvgPaths.pd79b800}
              fill="#EAEAEA"
              id="Vector_4"
            />
          </g>
          <path
            d={parkingSvgPaths.p24048800}
            fill="#EAEAEA"
            id="Vector_5"
          />
        </g>
      </svg>
    </div>
  );
}

// Parking Guide Card (원본 Container5와 동일)
function ParkingGuideCard() {
  return (
    <div
      className="bg-[#ffffff] relative rounded-2xl size-full"
      data-name="Container"
    >
      <div className="relative size-full">
        <div className="box-border content-stretch flex flex-row items-start justify-start overflow-hidden p-[40px] relative size-full">
          <ParkingContentContainer />
          <BackgroundCarComponent />
        </div>
      </div>
      <div
        aria-hidden="true"
        className="absolute border border-[#eaeaea] border-solid inset-0 pointer-events-none rounded-2xl"
      />
    </div>
  );
}

// Usage Guide Grid - Perfect Layout Matching
function Container14() {
  return (
    <div
      className="box-border content-stretch flex flex-col lg:flex-row gap-6 items-stretch justify-start p-0 relative shrink-0 w-full"
      data-name="Container"
    >
      {/* Left Column - Two Cards */}
      <div className="flex-1 flex flex-col gap-6 min-h-0">
        <div className="flex-1">
          <UsageInfoCard />
        </div>
        <div className="flex-1">
          <CautionCard />
        </div>
      </div>
      
      {/* Right Column - Single Card matching left column height */}
      <div className="flex-1 min-h-0">
        <ParkingGuideCard />
      </div>
    </div>
  );
}

// Usage Guide Section
function Section4() {
  return (
    <div
      className="box-border content-stretch flex flex-col gap-20 items-center justify-start pb-0 pt-20 px-0 relative shrink-0 w-full"
      data-name="Section"
    >
      <Container13 />
      <Container14 />
    </div>
  );
}

export function UsageSection() {
  return (
    <div
      className="bg-[#ececf0] relative shrink-0 w-full"
      data-name="Main Container"
    >
      <div className="overflow-clip relative size-full">
        <div className="box-border content-stretch flex flex-col gap-2.5 items-start justify-start left-1/2 px-4 py-[120px] relative translate-x-[-50%] w-[min(1280px,_calc(100vw_-_40px))]">
          <Section4 />
        </div>
      </div>
    </div>
  );
}